export class ErrorForApiPropertyModel {
  originalErrorMessage: string;
  timestamp: string;
  uri: string;
  userName: string;
  referenceNumber: string;
  httpErrorCode?: number;
}
